import apiAgent from "../../api/apiAgent";
import { useEffect, useState } from "react";
import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import _ from "lodash";
import { DisplayValue } from "../../components/DisplayValue";
import { EditButton } from "../../components/Button";
import { checkTitle } from "../../utils";
import { tMsg } from "../../components/ToastNotifications";
import { SetStateAction } from "jotai";
import {
  IndexPublishSection,
  PublishBannerByModel,
} from "../../components/Publishing";

const fetchItemData = async (
  itemName: string,
  setData: React.Dispatch<SetStateAction<any>>,
  setLoading: React.Dispatch<SetStateAction<boolean>>,
  setItemKeys?: React.Dispatch<SetStateAction<any[]>>,
  setSchema?: React.Dispatch<SetStateAction<any>>
) => {
  try {
    const response = await apiAgent.SingleItem.get(itemName);
    // console.log(response);

    if (response.status === 200) {
      const jsonData = JSON.parse(response.data.data);
      const displayData = {
        ...jsonData,
        // updatedAt: response.data.updated_at,
      };
      const getKeys = Object.keys(displayData);
      if (setItemKeys) setItemKeys(getKeys);
      if (setSchema) setSchema(JSON.parse(response.data.schema));
      setData(displayData);
    } else {
      tMsg.error(`${itemName} does not exist`);
      setData(null);
      if (setSchema) setSchema(null);
    }
  } catch (err) {
    console.log(err);
    redirect("/error");
  } finally {
    setLoading(false);
  }
};

const SettingsIndex = (): JSX.Element => {
  // const navigate = useNavigate();
  // const params = useParams();

  const itemName = "settings"; //params.item?.toString() || "unknown";
  const [data, setData] = useState<any>(null);
  const [schema, setSchema] = useState<any>(null);

  const [itemKeys, setItemKeys] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [placeData, setPlaceData] = useState<any>(null);
  const [placesLoading, setPlacesLoading] = useState<boolean>(true);

  const [topicData, setTopicData] = useState<any>(null);
  const [topicsLoading, setTopicsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchItemData("settings", setData, setIsLoading, setItemKeys, setSchema);
    fetchItemData("place", setPlaceData, setPlacesLoading);
    fetchItemData("topics", setTopicData, setTopicsLoading);
  }, [itemName]);

  // console.log(schema);
  return (
    <PageContainer isLoading={isLoading} className="relative">
      <PageContent>
        <BreadCrumbs crumbs={[]} />
        <TitleBar title={checkTitle(itemName)}>
          <Link to={`/si/${itemName}/edit`}>
            <EditButton />
          </Link>
        </TitleBar>
        <PublishBannerByModel modelName="settings" />
        <div className="flex flex-col gap-4 mt-5">
          {itemKeys.map((itemKey: any, index: number) => (
            <DisplayValue
              key={index}
              name={itemKey}
              value={data[itemKey]}
              type={!schema ? "text" : schema[itemKey] || "text"}
            />
          ))}
        </div>
        {topicData?.values && !topicsLoading && (
          <>
            <hr className="my-6" />
            <TitleBar
              title={
                <>
                  <div>Topics</div>
                  <div className="text-xs font-normal mt-2">
                    Topic tags that can be added to Moment/Landmark items
                  </div>
                </>
              }
            >
              <Link to={`/si/topics/edit`}>
                <EditButton />
              </Link>
            </TitleBar>
            <DisplayValue
              name="Options"
              value={topicData.values}
              type="string_array"
            />
          </>
        )}
        {placeData?.values && !placesLoading && (
          <>
            <hr className="my-6" />
            <TitleBar
              title={
                <>
                  <div>Places</div>
                  <div className="text-xs font-normal mt-2">
                    Place tags that can be added to Moment/Landmark items
                  </div>
                </>
              }
            >
              <Link to={`/si/place/edit`}>
                <EditButton />
              </Link>
            </TitleBar>
            <DisplayValue
              name="Options"
              value={placeData.values}
              type="string_array"
            />
          </>
        )}
      </PageContent>
    </PageContainer>
  );
};

export default SettingsIndex;
